import { getError } from "@/utils/get-error";
import { axiosInstance } from "@dexteel/mesf-core";
import { Axios } from "axios";
import { Vendor } from "../models/Vendor";

export class VendorsRepository {
	private axios: Axios;

	constructor() {
		this.axios = axiosInstance;

		this.getVendors = this.getVendors.bind(this);
		this.getVendorById = this.getVendorById.bind(this);
		this.createVendor = this.createVendor.bind(this);
		this.updateVendor = this.updateVendor.bind(this);
		this.deleteVendor = this.deleteVendor.bind(this);
	}

	async getVendors() {
		try {
			const vendors = await this.axios.get("/Vendor/");

			return {
				ok: true,
				vendors: vendors.data,
			};
		} catch (error: any) {
			const message = getError(error);
			return Promise.reject(message);
		}
	}

	async getVendorById(vendorId: number | null) {
		try {
			const vendor = await this.axios.get(`/Vendor/${vendorId}`);
			return {
				ok: true,
				vendor: vendor.data,
			};
		} catch (error) {
			return {
				ok: false,
				error,
			};
		}
	}

	async createVendor({ vendorName, nsblVendorId }: Vendor) {
		try {
			await this.axios.post("/Vendor/", {
				vendorName,
				nsblVendorId,
				isActive: true,
			});

			return {
				ok: true,
			};
		} catch (error: any) {
			const message = getError(error);

			return Promise.reject(message);
		}
	}

	async updateVendor(vendorId: number | null, vendorData: Vendor) {
		try {
			await this.axios.patch(`/Vendor/${vendorId}`, vendorData);
			return {
				ok: true,
			};
		} catch (error: any) {
			const message = getError(error);

			return Promise.reject(message);
		}
	}

	async deleteVendor(vendorId: number | null) {
		try {
			await this.axios.delete(`/Vendor/`, {
				params: { vendorId },
			});
			return {
				ok: true,
			};
		} catch (error: any) {
			const message = getError(error);

			return Promise.reject(message);
		}
	}
}

export const {
	getVendors,
	getVendorById,
	createVendor,
	updateVendor,
	deleteVendor,
} = new VendorsRepository();
